import React, { FC, useState } from "react";
import UIcon from "../../components/UIcon";
import './HeaderIcon.scss';
import { getCurrentLanguage } from '../../i18n';

interface HeaderIconProps {
  color?: string;
  isRelative?: boolean;
  goToTop?: boolean;
  hasSlideDelay?: boolean;
  onClick?: any
}

const HeaderIcon: FC<HeaderIconProps> = ({ color, isRelative, goToTop, hasSlideDelay, onClick }) => {
  const currentLanguage = getCurrentLanguage();
  const [homeLink] = useState(`/${currentLanguage}/`);

  const goTop = () => {
    onClick(0);
  };
  
  return (
    <div className={`header-icon ${isRelative ? 'header-icon--relative' : ''} ${hasSlideDelay ? 'is-delayed' : ''}`}>
      <a href={goToTop ? null : homeLink} data-cursor-text='Home' onClick={goToTop ? goTop : null}>
        <UIcon color={color ? color : "#fff"} />
      </a>
    </div>
  );
};

export default HeaderIcon;
